// extracted by mini-css-extract-plugin
export default {"darkCalendar":"DashboardCalendar_darkCalendar__Vstqf"};